import ColorText from "./ColorText";

export default function ColorTextPage() {
  return (
    <>
      <ColorText color="skyblue" />
      <ColorText color="seagreen" />
      <ColorText color="teal" />
    </>
  );
}
